export default __webpack_public_path__ + "static/media/carousel-2.6631b543.jpg";